import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grow-0 min-h-10 grid grid-cols-4 gap-2 py-4" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "text-right" }
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = { class: "flex justify-end pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event))
  }, {
    header: _withCtx(() => _cache[2] || (_cache[2] = [
      _createElementVNode("div", null, [
        _createElementVNode("h2", { class: "text-lg font-bold" }, "Riepilogo Fees")
      ], -1)
    ])),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "font-bold" }, "Nome", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "font-bold" }, "Valore", -1)),
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "font-bold text-right" }, "Budget imponibile", -1)),
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "font-bold text-right" }, "Budget lordo IVA", -1)),
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "col-span-4 border-b" }, null, -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Fees, (f) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(f.nome), 1),
            _createElementVNode("span", _hoisted_3, _toDisplayString(f.valore) + " %", 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString((f.valore * f.budget / 100).toLocaleValueString(2, 2)) + " €", 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString((f.valore * f.budget * 0.0122).toLocaleValueString(2, 2)) + " €", 1)
          ], 64))
        }), 256))
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_NextButton, {
          variant: "outline-secondary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:visible', false))),
          class: "col-start-3 py-2 px-4"
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createTextVNode(" Chiudi ")
          ])),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}